import { Link } from 'react-router-dom';
import { BRAND_NAME } from '@/mocks/categories';

const features = [
  { icon: 'ri-hd-line', title: '高清影音资源', desc: '汇集国语对白高清影音作品，画质与音质信息一目了然。' },
  { icon: 'ri-apps-2-line', title: '多维分类浏览', desc: '电影、电视剧、综艺、纪录片按题材与地区精细分类。' },
  { icon: 'ri-search-eye-line', title: '快速精准搜索', desc: '支持名称、主演、关键词模糊搜索，快速定位想看的内容。' },
  { icon: 'ri-bookmark-3-line', title: '本地收藏管理', desc: '一键收藏感兴趣的作品，收藏记录保存在本地浏览器。' },
];

export default function SiteIntro() {
  return (
    <section className="bg-background-100 border-y border-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">
            <i className="ri-information-line"></i>
            关于本站
          </span>
          <h2 className="mt-4 text-2xl md:text-3xl font-bold text-foreground-950">
            {BRAND_NAME}，你的国语影音资源导航站
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            本站聚焦国语对白影视及影音内容，面向国语影视爱好者、影音资源搜集者与普通观众，
            提供详尽的作品分类、资源信息与多维筛选能力，帮助你在丰富的国语影音作品中快速找到想看的内容。
            所有资源信息均为集中展示与导航，播放链接仅作界面演示。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {features.map((f) => (
            <div key={f.title} className="p-5 bg-background-50 border border-background-200 rounded-lg">
              <span className="w-11 h-11 rounded-md bg-secondary-100 text-secondary-600 flex items-center justify-center">
                <i className={`${f.icon} text-2xl`}></i>
              </span>
              <h3 className="mt-4 font-semibold text-foreground-950">{f.title}</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-wrap items-center gap-3">
          <Link
            to="/about"
            className="inline-flex items-center gap-1.5 h-11 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors"
          >
            了解更多
            <i className="ri-arrow-right-line"></i>
          </Link>
          <Link
            to="/contact"
            className="inline-flex items-center gap-1.5 h-11 px-6 rounded-md border border-background-300 text-foreground-800 text-sm font-medium whitespace-nowrap hover:border-primary-300 hover:text-primary-500 transition-colors"
          >
            意见反馈
          </Link>
        </div>
      </div>
    </section>
  );
}